import React from 'react'
import PropTypes from 'prop-types'
import AptitudeQuestionItemRiasec from 'components/molecules/AptitudeQuestionItemRiasec'
import AptitudeQuestionItemCharc from 'components/molecules/AptitudeQuestionItemCharc'

class AptitudeQuestionItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      answer: 0,
    }

    this.updateAnswer = this.updateAnswer.bind(this)
  }

  updateAnswer(newAnswer) {
    this.setState({ answer: newAnswer }, () => {
      this.props.onAnswer()
      this.saveAnswerToLocalStorage(this.props.id, newAnswer)
    })
  }

  saveAnswerToLocalStorage(id, answer) {
    if (typeof localStorage !== 'undefined') {
      // load from localstorage
      let answers = localStorage.getItem('aptitude_answers') || '{}'
      answers = JSON.parse(answers)
      // update answer value
      answers[id] = answer
      // save to localstorage
      answers = JSON.stringify(answers)
      localStorage.setItem('aptitude_answers', answers)
    }
  }

  render() {
    const { factorGroup } = this.props
    const Component = factorGroup === 'riasec' ? AptitudeQuestionItemRiasec : AptitudeQuestionItemCharc

    return (
      <Component
        {...this.props}
        onClickHandler={this.updateAnswer}
        answer={this.state.answer}
      />
    )
  }
}

const questionProps = {
  id: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  factorGroup: PropTypes.string.isRequired,
  onAnswer: PropTypes.func.isRequired,
  number: PropTypes.number.isRequired,
}

AptitudeQuestionItem.propTypes = questionProps

export default AptitudeQuestionItem
